<template>
  <section class="row mt-3" v-if="tab === historico_agendamentos">
    <div class="col-12" v-if="!historicoAtendimentoStore.state?.loading">
      <div class="d-flex align-items-center justify-content-between mb-4">
        <h3 class="mb-0 text-gray-800 font-weight-bolder">
          {{ $t("Histórico de Agendamentos") }}
        </h3>
        <b-button-group>
          <b-button
            variant="outline-dark"
            :class="viewFilterReport === true ? 'active' : ''"
            @click="viewFilters"
          >
            <i class="fas fa-filter"></i>
            {{ $t("Filtros") }}
          </b-button>
          <b-button
            variant="outline-dark"
            :class="range === 'weekly' ? 'active' : ''"
            @click="updateRange('weekly')"
          >
            <i class="fas fa-calendar-week"></i>
            {{ $t("Weekly") }}
          </b-button>
          <b-button
            variant="outline-dark"
            :class="range === 'monthly' ? 'active' : ''"
            @click="updateRange('monthly')"
          >
            <i class="fas fa-calendar-alt"></i>
            {{ $t("Monthly") }}
          </b-button>
          <b-button
            variant="outline-dark"
            :class="range === 'yearly' ? 'active' : ''"
            @click="updateRange('yearly')"
          >
            <i class="fas fa-calendar"></i>
            {{ $t("Yearly") }}
          </b-button>
          <b-button
            variant="outline-dark"
            :title="$t('Imprimir')"
            v-b-tooltip.hover
            @click="print()"
          >
            <i class="fas fa-print"></i>
          </b-button>
          <b-button
            variant="outline-dark"
            :title="$t('Exportar')"
            v-b-tooltip.hover
            @click="exportar()"
          >
            <i class="fas fa-file-excel"></i>
          </b-button>
        </b-button-group>
      </div>
    </div>
    <div class="col-12" v-if="viewFilterReport">
      <form @submit.prevent="getHistorico">
        <div class="row">
          <form-calendar
            label="Data inicial"
            grid="3"
            v-model="filtro.data_inicial"
          />

          <form-calendar
            grid="3"
            label="Data final"
            :required="filtro.data_inicial"
            :min-date="filtro.data_inicial"
            v-model="filtro.data_final"
          />

          <form-select
            v-if="!isTecnico"
            label="Filtrar por Unidade"
            grid="6"
            :loading="agendamentosStore?.state?.loadingSelectOptions"
            :itens="agendamentosStore?.state?.unidades_internas"
            v-model="filtro.unidade_id"
          />

          <form-select
            label="Filtrar por Status"
            grid="3"
            :loading="agendamentosStore?.state?.loadingSelectOptions"
            :itens="agendamentosStore?.state?.agenda_status"
            v-model="filtro.status_id"
          />

        </div>
        <div class="row pt-4 px-0 d-flex justify-content-end mb-3">
          <div class="col-auto px-2 text-right">
            <button class="btn btn-default" @click="viewFilters">
              <i class="fas fa-times"></i>
            </button>

            <button
              type="button"
              class="btn btn-secondary"
              @click.prevent="limparFiltros"
            >
              {{ $t("Limpar Filtros") }}
            </button>
            <button
              class="btn btn-success btn-submit"
              data-style="zoom-in"
              type="submit"
            >
              <i class="fas fa-chart-bar"></i>
              {{ $t("Filtrar") }}
            </button>
          </div>
        </div>
      </form>
    </div>

    <loading-report
      :loading="historicoAtendimentoStore.state?.loading"
      mensagem="Por favor aguarde estamos realizando sua solicitação..."
      icone="fa-smile-wink"
    />
    <load v-if="historicoAtendimentoStore.state?.loading" mode="table" />

    <div class="col-12" v-else>
      <print-content>
        <template v-slot:datas>
          <section
            style="column-gap: 35px; display: flex; flex-wrap: wrap; align-items: center"
          >
            <span style="color: #67686b; line-height: 1.8; margin-bottom: 10px;">
              Unidade:
              <b> {{ unidade }} </b>
            </span>
            <span style="color: #67686b; line-height: 1.8; margin-bottom: 10px;" v-if="datas.start">
              Período de pesquisa selecionado:
              <b> {{ datas.start }} - {{ datas.end }} </b>
              <b-link
                href="#"
                @click.prevent="void 0"
                class="mb-2"
                variant="info"
                v-b-popover.hover.top="'Através do botão filtros você pode selecionar um intervalo de datas para impressão de seus dados.'"
              >
                <i class="fas fa-info-circle"></i>
              </b-link>
            </span>
          </section>
        </template>
        <b-table
          :fields="[
            {
              key: 'atendimento',
              label: $t('Detalhes'),
            },
            {
              key: 'agendamentos',
              label: $t('Data e hora agendada'),
              thStyle: { width: '300px', minWidth: '300px' },
            },
          ]"
          :items="historicoAtendimentoStore.state?.historico"
          :responsive="true"
          striped
          hover
          show-empty
          small
          outlined
          stacked="xs"
          table-class="mb-3"
        >
          <template v-slot:cell(atendimento)="data">
            Usuário(s):<br />
            <ul>
              <li v-for="pessoa in data.item?.usuarios" :key="pessoa">
                <strong>{{ pessoa }}</strong>
              </li>
            </ul>
            Contato: <b>{{ data.item?.beneficiario?.telefone }}</b>
            <br />
            Forma de acesso: <b>{{ data.item?.atendimento?.forma_acesso }}</b>
            <br />
            Tipo(s):
            <br />
            <ul>
              <li v-for="tipo in data.item?.atendimento?.tipos" :key="tipo">
                <strong>{{ tipo }}</strong>
              </li>
            </ul>
            Local:
            <b>{{ data.item?.atendimento?.local_atendimento }}</b>
            <br />
            Serviço:
            <b>{{ data.item?.atendimento?.servico }}</b>
            <br />
            Data da solicitação:
            <b>{{ data.item?.atendimento?.data_solicitacao | formatDate() }}</b>
            <br />
            Necessita intérprete de Libras:
            <b>{{ data.item?.beneficiario?.necessita_interprete_libras ? "Sim" : "Não" }}</b>
            <template v-if="data.item?.beneficiario?.situacao_rua">
              <br />
              <b-icon
                icon="exclamation-triangle-fill"
                variant="warning"
                animation="fade"
              >
              </b-icon>
              Situação de rua
            </template>
          </template>
          <template v-slot:cell(agendamentos)="data">
            Data e hora agendada:
            <br />
            <ul v-for="agendamento in data.item?.atendimento?.agendamentos[0]" :key="agendamento">
              <li>
                <strong>
                  {{ agendamento?.dia | formatDate() }} - {{ agendamento?.hora_inicio }} às {{ agendamento?.hora_fim }}
                </strong>
              </li>
              <li style="margin-left: 1.5em;">
                <strong :style="{ color: agendamento?.status?.cor }">
                  {{ agendamento?.status.descricao }}
                </strong>
              </li>
              <li v-if="agendamento?.motivo" style="margin-left: 1.5em;">
                <b-icon
                  icon="exclamation-triangle-fill"
                  variant="warning"
                  animation="fade"
                />
                <strong :style="{ color: agendamento?.status?.cor }">
                  {{ agendamento?.motivo }}
                </strong>
              </li>
            </ul>
          </template>
          <template v-slot:empty="scope">
            <div class="text-center my-5">
              <img
                :alt="$t('No results')"
                class="mb-5"
                src="/img/icons/robot.svg"
                style="max-height: 165px"
              />
              <h3 class="bold">
                {{ $t("No records found") }}
              </h3>
            </div>
          </template>
        </b-table>
      </print-content>
      <div class="row align-items-center no-print">
        <div class="col-lg-6 col-md-12">
          <div class="form-group d-inline-flex mb-0">
            <select
              class="form-control"
              style="width: 70px"
              v-model="perPage"
              v-on:change="getHistorico"
            >
              <option value="5">5</option>
              <option value="10">10</option>
              <option value="25">25</option>
              <option value="50">50</option>
            </select>
          </div>
          <div class="d-inline-flex ml-2">
            <b-pagination
              :per-page="perPage"
              :total-rows="pagination.total"
              @change="changePage"
              v-model="page"
            />
          </div>
        </div>
        <div class="col-lg-6 col-md-12 mt-4 mt-lg-0">
          <div class="float-lg-right">
            {{ $t("Showing page") }}
            {{ pagination.currentPage }} {{ $t("of") }}
            {{ pagination.totalPages }}
            {{ $t("pages in") }}
            {{ pagination.total }}
            {{ $t("records") }}
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "HistoricoAtendimentos",
  inject: ["agendamentosStore", "historicoAtendimentoStore"],
  props: ["tab"],
  data() {
    return {
      historico_agendamentos: "historico_agendamentos",
      perPage: 10,
      page: 1,
      pagination: {
        currentPage: 0,
        perPage: 0,
        total: 0,
        totalPages: 0,
      },
      range: "",
      isTecnico: this.$store.state.user?.role_details?.name?.toLowerCase()?.includes("técnico"),
      tecnicoLogado: this.$store.state.user.tecnico,
      filtro: {
        unidade_id: null,
        status_id: null,
        data_inicial: null,
        data_final: null
      },
      datas: {
        start: null,
        end: null
      },
      unidade: null,
    }
  },
  watch: {
    tab(newVal) {
      if (newVal === this.historico_agendamentos) this.getHistorico();
    },

    filtro: {
      handler: function (newVal) {
        const unidade = this.agendamentosStore?.state?.unidades_internas.find(
          (e) => e.id === newVal.unidade_id
        );

        this.historicoAtendimentoStore.commit("SET_UNIDADE", unidade || null);
      },
      deep: true
    }
  },
  methods: {
    updateRange(range) {
      if (this.range !== range) {
        this.range = range;
        this.getHistorico();
      }
    },

    limparFiltros() {
      Object.assign(this.$data, this.$options.data.call(this));
      this.getHistorico();
    },

    changePage(page) {
      if (page > 0 && page <= this.pagination.totalPages && page !== this.page) {
        this.page = page;
        this.getHistorico();
      }
    },

    async getHistorico() {
      if (this.filtro.data_final && this.filtro.data_inicial) this.range = "range";

      await this.historicoAtendimentoStore.dispatch("getHistorico", {
        perPage: this.perPage,
        range: this.range,
        page: this.page,
        filtro: {
          ...this.filtro,
          unidade_id: this.historicoAtendimentoStore.state?.unidade?.id || this.tecnicoLogado?.unidade?.id,
        },
      }).then(r => {
        if (r.status === 200) {
          this.datas = r.data.dates;
          this.pagination = r.data.pagination;
          this.unidade = r.data.unidade;

          if (this.pagination.totalPages < this.pagination.currentPage) {
            this.page = this.pagination.totalPages;
            this.getHistorico();
          }
        }
      });
    },

    exportar() {
      swal.fire({
        title: "Aguarde",
        text: "O Arquivo está sendo gerado.",
        imageUrl: `${window.urlbase}img/load.gif`,
        showConfirmButton: false,
      });

      this.historicoAtendimentoStore.dispatch("getExportHistorico", {
        range: this.range,
        filtro: {
          ...this.filtro,
          unidade_id: this.historicoAtendimentoStore.state?.unidade?.id || this.tecnicoLogado?.unidade?.id,
        },
      }).then(response => {
        if (response.status === 200) {
          swal.fire({
            title: "Arquivo Pronto para Download!",
            html: `<a href="${response.data.link}" target="_blank">Clique aqui para baixar</a>`,
            icon: "success",
            showConfirmButton: false,
          });
        }
      });
    },
  }
}
</script>
